import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import RealisationEurojustLaHaye from "../components/RealisationEurojustLaHaye";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealisationEurojustLaHaye);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/RealisationEurojustLaHaye.js